import Login from "./Components/Login/Login";
import Roles from "./Components/Roles/Roles";
import DownloadFiles from "./Pantallas_Finales/Archivos_Descargas/Archivo_Descarga";
import HomeModuls from "./Pantallas_Finales/Home_Modulos/HomeModuls";
import Registros from "./Pantallas_Finales/Registros/Registros";
import RegistrosUsuarios from "./Pantallas_Finales/RegistrosUsuarios/RegistrosUsuarios";


export const rutas = [
    { ruta: '/login', component: <Login />},
    { ruta: '/main', component: <HomeModuls />},

    { ruta: '/archivos', component: <DownloadFiles /> },
    { ruta: '/historial', component: <Registros /> },
    { ruta: '/usuarios', component: <RegistrosUsuarios /> },

    { ruta: '/admonRoles', component: <Roles /> },
]